module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper add-user",
    on: {
      "click": _vm.addNewAccount
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Создать пользователя панели администратора\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "accounts"
  }, _vm._l((_vm.accountsData), function(account) {
    return _c('AccountItem', {
      key: account.id,
      attrs: {
        "account": account,
        "roles": _vm.roles
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d84b58b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Accounts/Index.vue
// module id = 944
// module chunks = 0